"use client";
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import PopOver from "../../atoms/popOver";
import ZoomGalleryLayout from "./zoomGalleryLayout";
import isEmpty from "lodash.isempty";
import isMobile from "../../../utils/common";

/**
 * Component that handles the selection of add-ons,
 * allowing users to choose from available options and manage their selections.
 *
 * @returns {JSX.Element} The rendered add-on selection component.
 */
const ZoomGallery = ({ productImages, productVideoLink }) => {
  const galleryClickedImage = useSelector((state) => state.pdp.galleryClickedImage);
  const modifiedProductMedia = useMemo(() => {
    const updatedProductImages = productImages?.slice();
    !isEmpty(productVideoLink) && productImages?.length
      ? updatedProductImages?.splice(1, 0, productVideoLink)
      : updatedProductImages;
    return updatedProductImages;
  }, [productVideoLink, productImages]);

  return (
    <>
      <PopOver
        isVisible={!isEmpty(galleryClickedImage?.url)}
        classes={`md:top-[10%] md:bottom-auto md:overflow-y-hidden md:left-[19%] w-[100%] md:w-[60%] rounded-none md:rounded-2xl ${isMobile() && "h-[100dvh]"}`}
        isBackdrop={true}
      >
        <ZoomGalleryLayout productImages={modifiedProductMedia} productVideoLink={productVideoLink} />
      </PopOver>
    </>
  );
};

export default ZoomGallery;

ZoomGallery.propTypes = {
  productImages: PropTypes.array.isRequired,
  productVideoLink: PropTypes.string,
};
